<!-- <template>
	<div class="vue-video" v-if="src">
		<video-aplayer class="video-player vjs-custom-skin" ref="videoPlayer" :options="options" @play="onPlayerPlay" @pause="onPlayerPause" @ended="onPlayerEnded" @timeupdate="onPlayerTimeupdate"></video-aplayer>
		<type-grid class="vue-video-text" row="11" margin v-if="title || subtitle">
			<type-grid row="11" padding v-if="title">
				<type-text type="title" size="max" align="center" padding="0">{{ title }}</type-text>
			</type-grid>
			<type-grid row="11" padding v-if="subtitle">
				<type-text type="content" size="9" align="center" padding="0">{{ subtitle }}</type-text>
			</type-grid>
		</type-grid>
	</div>
</template>

<script>
	import 'vue-video-player/node_modules/video.js/dist/video-js.css'
	import 'vue-video-player/src/custom-theme.css'
	import { videoPlayer } from 'vue-video-player'
    // import 'video.js/dist/video-js.css'
	export default {
		name: 'vue-video',
		props: {
			src: {
				type: String,
				default: './rowingsamplevideo.mp4'
				// default: 'https://panvr.xitohere.com/xito/static/media/rowingsamplevideo.09906aa1.mp4'
			},
			title: {
				type: String,
				default: ''
			},
			subtitle: {
				type: String,
				default: ''
			},
			breakpoint: {
				type: Number,
				default: -1
			}
		},
		data() {
			const src = this.src;
			return {
				isPlay: false,
				options: {
					playbackRates: [ 0.5, 1.0, 1.5, 2.0 ], //播放速度
					autoplay: true, //如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: true, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4",
						src: src
					}],
					// poster:require('../../../../assets/image/music.png'), //你的封面地址
					// width: document.documentElement.clientWidth, //播放器宽度
					notSupportedMessage: 'no video playable', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: true,
						fullscreenToggle: true //全屏按钮
					},
					controlBar: false
					// controls: false
				}
			}
		},
		watch: {
			breakpoint() {
				// 继续播放
				this.player.play();
			}
		},
		methods: {
			onPlayerPlay(event) {
				this.isPlay = true;
			},
			onPlayerPause(event) {
				this.isPlay = false;
			},
			onPlayerEnded(event) {
				this.isPlay = false;
			},
			onPlayerTimeupdate(event) {
				const currentTime = event.currentTime();
				// 触发断点
				if (this.breakpoint && this.breakpoint > 0 && currentTime > this.breakpoint) {
					if (this.isPlay) {
						//this.isPlay = false;
						//this.player.pause();
						//this.$emit('break-play', currentTime);
					}
				}
			}
		},
		computed: {
			player() {
				return this.src && this.$refs.videoPlayer.player;
			}
		},
		components: {
			'video-aplayer': videoPlayer
		}
	}
</script>

<style>
	.video-js .vjs-icon-placeholder{
	    width: 100%;
	    height: 100%;
	    display: block;
	}
	
	/* 覆盖 video.js 默认的控制条样式 */
	.vjs-control-bar {
	    /* 你可以在这里添加自定义样式，比如调整位置、大小等 */
	}
	
	/* 调整播放按钮的位置 */
	.vjs-custom-skin > .video-js .vjs-big-play-button {
	    position: absolute;
	    top: 90%; /* 调整水平位置 */
	    left: 90%; /* 调整垂直位置 */
		font-size: 2.4em;
	    transform: translate(-50%, -50%); /* 使按钮居中 */
	}
</style>
<style scoped lang="less">
	.vue-video{
		width: 100%;
		overflow: hidden;
		position: relative;
		.vue-video-text{
			position: absolute;
			// top: 50%;
			left: 50%;
			z-index: 10;
			bottom: 20px;
			color: #FFFFFF;
			margin: 0 !important;
			pointer-events: none;
			transform: translateX(-50%);
			// transform: translate(-50%, -50%);
			// .title-text{
			// 	text-shadow: 2px 2px 20px #000000;
			// }
			// .content-text{
			// 	text-shadow: 2px 2px 15px #363636;
			// }
		}
	}
</style> -->



<template>
    <div class="vue-video" v-if="src">
        <video-aplayer 
            class="video-player vjs-custom-skin" 
            ref="videoPlayer" 
            :options="options" 
            @play="onPlayerPlay" 
            @pause="onPlayerPause" 
            @ended="onPlayerEnded" 
            @timeupdate="onPlayerTimeupdate"
            @ready="onPlayerReady"
        ></video-aplayer>
        <type-grid class="vue-video-text" row="11" margin v-if="title || subtitle">
            <type-grid row="12" padding v-if="title">
                <type-text type="title" size="max" align="center" padding="0">{{ title }}</type-text>
            </type-grid>
            <type-grid row="12" padding v-if="subtitle">
                <type-text type="content" size="9" align="center" padding="0">{{ subtitle }}</type-text>
            </type-grid>
        </type-grid>
        <!-- Unmute button overlay -->
        <div v-if="isMuted && isPlay" class="unmute-overlay" @click="toggleMute">
            <button class="unmute-button">Unmute</button>
        </div>
    </div>
</template>

<script>
    import 'vue-video-player/node_modules/video.js/dist/video-js.css'
    import 'vue-video-player/src/custom-theme.css'
    import { videoPlayer } from 'vue-video-player'

    export default {
        name: 'vue-video',
        props: {
            src: {
                type: String,
                default: './rowingsamplevideo.mp4'
            },
            title: {
                type: String,
                default: ''
            },
            subtitle: {
                type: String,
                default: ''
            },
            breakpoint: {
                type: Number,
                default: -1
            },
            // New prop to control if video should start muted
            startMuted: {
                type: Boolean,
                default: true
            }
        },
        data() {
            const src = this.src;
            return {
                isPlay: false,
                isMuted: this.startMuted,
                options: {
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    autoplay: true, // This will work because we're muting the video
                    muted: this.startMuted, // CRITICAL: Must be true for autoplay to work
                    loop: true,
                    preload: 'auto',
                    language: 'zh-CN',
                    aspectRatio: '16:9',
                    fluid: true,
                    sources: [{
                        type: "video/mp4",
                        src: src
                    }],
                    notSupportedMessage: 'This video cannot be played on your browser',
                    // Fixed: Remove conflicting controlBar settings
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true,
						currentTimeDisplay: false,
                        volumePanel: {
                            inline: false // Show volume control
                        }
                    },
                    // Remove this line as it conflicts with the controlBar object above
                    // controlBar: false
                    
                    // Additional options to help with autoplay
                    techOrder: ['html5'],
                    html5: {
                        vhs: {
                            overrideNative: true
                        }
                    }
                }
            }
        },
        watch: {
            breakpoint() {
                if (this.player) {
                    this.player.play().catch(error => {
                        console.warn('Play failed:', error);
                    });
                }
            }
        },
        methods: {
            onPlayerReady() {
                console.log('Player is ready');
                // Force play after player is ready
                this.$nextTick(() => {
                    this.forceAutoplay();
                });
            },
            
            async forceAutoplay() {
                if (this.player) {
                    try {
                        // Try to play
                        await this.player.play();
                        console.log('Autoplay successful');
                    } catch (error) {
                        console.warn('Autoplay failed, trying with muted:', error);
                        // If autoplay fails, ensure it's muted and try again
                        this.player.muted(true);
                        this.isMuted = true;
                        try {
                            await this.player.play();
                            console.log('Autoplay successful with muted');
                        } catch (mutedError) {
                            console.error('Autoplay failed even when muted:', mutedError);
                            // Show play button or handle gracefully
                            this.handleAutoplayFailure();
                        }
                    }
                }
            },
            
            handleAutoplayFailure() {
                // You can emit an event or show a message to user
                this.$emit('autoplay-failed');
                console.log('Autoplay blocked by browser. User interaction required.');
            },
            
            toggleMute() {
                if (this.player) {
                    const currentMutedState = this.player.muted();
                    this.player.muted(!currentMutedState);
                    this.isMuted = !currentMutedState;
                }
            },
            
            onPlayerPlay(event) {
                this.isPlay = true;
                console.log('Video started playing');
            },
            
            onPlayerPause(event) {
                this.isPlay = false;
                console.log('Video paused');
            },
            
            onPlayerEnded(event) {
                this.isPlay = false;
                console.log('Video ended');
            },
            
            onPlayerTimeupdate(event) {
                const currentTime = event.currentTime();
                if (this.breakpoint && this.breakpoint > 0 && currentTime > this.breakpoint) {
                    if (this.isPlay) {
                        // Uncomment these lines if you want to pause at breakpoint
                        // this.isPlay = false;
                        // this.player.pause();
                        // this.$emit('break-play', currentTime);
                    }
                }
            }
        },
        computed: {
            player() {
                return this.src && this.$refs.videoPlayer && this.$refs.videoPlayer.player;
            }
        },
        mounted() {
            // Additional check after component is mounted
            this.$nextTick(() => {
                if (this.player) {
                    this.forceAutoplay();
                }
            });
        },
        components: {
            'video-aplayer': videoPlayer
        }
    }
</script>

<style>
    .video-js .vjs-icon-placeholder {
        width: 100%;
        height: 100%;
        display: block;
    }
    /* Custom big play button positioning */
    .vjs-custom-skin .video-js .vjs-big-play-button {
        position: absolute;
        top: 90%;
        left: 90%;
        font-size: 2.4em;
        transform: translate(-50%, -50%);
        z-index: 5;
    }
    
    /* Ensure controls are visible */
    .vjs-custom-skin .vjs-control-bar {
        display: flex !important;
        opacity: 1;
        background: rgba(0, 0, 0, 0.7);
    }
</style>

<style scoped lang="less">
    .vue-video {
        width: 100%;
        overflow: hidden;
        position: relative;
        font-size:0;
        display: block;
        
        .vue-video-text {
            position: absolute;
            left: 50%;
            z-index: 10;
            bottom: 20px;
            color: #FFFFFF;
            margin: 0 !important;
            pointer-events: none;
            transform: translateX(-50%);
        }
        
        .unmute-overlay {
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 15;
            pointer-events: auto;
            
            .unmute-button {
                background: rgba(0, 0, 0, 0.8);
                color: white;
                border: none;
                padding: 10px 15px;
                border-radius: 5px;
                cursor: pointer;
                font-size: 40px;
                
                &:hover {
                    background: rgba(0, 0, 0, 0.9);
                }
            }
        }
    }


</style>